/*
 * Search suggestions — popular terms and the shopper's own recent searches.
 *
 * Recent searches are kept in localStorage on the shopper's device and never
 * sent anywhere. The tracking-page privacy work in Agenda 12 is the reason
 * this is spelled out: search terms can be personal.
 *
 * The panel is shown only while the input is empty, so it never competes with
 * Shopify's predictive results.
 */
(function () {
  'use strict';

  var STORE_KEY = 'alaya:recent-searches';
  var MAX_RECENT = 5;

  function readRecent() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (t) {
        return typeof t === 'string' && t.trim() !== '';
      }) : [];
    } catch (e) {
      // Private mode, disabled storage, or corrupted JSON. Recent searches are
      // a convenience — never let them break the search box.
      return [];
    }
  }

  function writeRecent(terms) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(terms.slice(0, MAX_RECENT)));
    } catch (e) {
      /* ignore — see readRecent */
    }
  }

  function rememberTerm(term) {
    var clean = (term || '').trim();
    if (clean === '') return;
    var terms = readRecent().filter(function (t) {
      return t.toLowerCase() !== clean.toLowerCase();
    });
    terms.unshift(clean);
    writeRecent(terms);
  }

  function searchHref(term) {
    return (
      window.routes && window.routes.search_url
        ? window.routes.search_url
        : '/search'
    ) +
      '?q=' +
      encodeURIComponent(term) +
      '&type=product&options%5Bunavailable_products%5D=hide';
  }

  function renderRecent(panel) {
    var group = panel.querySelector('[data-recent-searches]');
    var list = panel.querySelector('[data-recent-list]');
    if (!group || !list) return;

    var terms = readRecent();
    if (terms.length === 0) {
      group.hidden = true;
      group.classList.add('hidden');
      return;
    }

    list.textContent = '';
    terms.forEach(function (term) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'search-suggest__chip search-suggest__chip--recent';
      a.href = searchHref(term);
      a.textContent = term; // textContent, not innerHTML — the term is user input
      li.appendChild(a);
      list.appendChild(li);
    });

    group.hidden = false;
    group.classList.remove('hidden');
  }

  function wire(form) {
    var panel = form.querySelector('[data-search-suggest]');
    var input = form.querySelector('input[name="q"]');
    if (!panel || !input) return;

    renderRecent(panel);

    function sync() {
      // Empty field: offer suggestions. Anything typed: get out of the way so
      // predictive results own the space.
      panel.classList.toggle('search-suggest--hidden', input.value.trim() !== '');
    }

    sync();
    input.addEventListener('input', sync);
    input.addEventListener('focus', sync);

    form.addEventListener('submit', function () {
      rememberTerm(input.value);
    });

    // An anchor rather than a button — see the comment in header-search.liquid.
    // It carries a real href so it still does something without JS, which means
    // the default navigation has to be suppressed here.
    var clear = panel.querySelector('[data-clear-recent]');
    if (clear) {
      clear.addEventListener('click', function (event) {
        event.preventDefault();
        writeRecent([]);
        renderRecent(panel);
      });
    }
  }

  function init() {
    document.querySelectorAll('form[action*="search"]').forEach(function (form) {
      if (form.dataset.searchSuggestWired === 'true') return;
      form.dataset.searchSuggestWired = 'true';
      wire(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
